import noUiSlider from 'nouislider';
import wNumb from 'wnumb';

function updateAll(sliders, value, originalType) {
    const updatedType = originalType == 'months' ? 'years' : 'months';
    const fakeAgeSlider = document.querySelector(`.js-filter-age-slider[data-type="${updatedType}"]`);
    const hiddenAgeInput = document.querySelector(`.js-filter-age-from`);

    // set the other fake slider
    sliders[fakeAgeSlider.dataset.id].set([originalType == 'months' ? Math.floor(+value / 12) : +value * 12, null])
    fakeAgeSlider.closest('.js-filter-age-slider-holder').querySelector('.js-filter-age-fake-from').value = originalType == 'months' ? Math.floor(+value / 12) : +value * 12;

    // set the hidden input fo age filtering
    hiddenAgeInput.value = originalType == 'months' ? value : value * 12;

    // submit the filter
    Filter.submit();
}

function initFilterAgeSliders() {
    const sliderElements = document.querySelectorAll('.js-filter-age-slider'),
        sliders = [];

    if (sliderElements.length) {
        sliderElements.forEach(slider => {
            const elem = slider.querySelector('.js-filter-age-slider-elem'),
                wrapper = elem.closest('.c-filter-slider'),
                type = slider.dataset.type,
                maxValue = Number(slider.dataset.max),
                minValue = Number(slider.dataset.min),
                fromValue = Number(slider.dataset.from),
                sliderId = slider.dataset.id,
                fromInput = wrapper.querySelector(`.js-filter-age-fake-from`);

            sliders[sliderId] = noUiSlider.create(elem, {
                start: [fromValue],
                range: {
                    'min': [minValue],
                    'max': [maxValue]
                },
                margin: 1,
                connect: true,
                tooltips: [
                    wNumb({
                        decimals: 0,
                    }),
                ],
                step: 1
            });

            sliders[sliderId].on('change', (values, handle) => {
                fromInput.value = Number(values[0]);
                updateAll(sliders, fromInput.value, type);
            });

            fromInput.addEventListener('change', event => {
                event.preventDefault();

                const min = Number(fromInput.getAttribute('min'));
                    /*toInputValue = Number(toInput.value);*/

                let value = Number(fromInput.value),
                    setInput = false;

                if (value < min) {
                    value = min;
                    setInput = true;
                }
                /*else if (value > toInputValue) {
                    value = toInputValue;
                    setInput = true;
                }*/

                if (setInput) {
                    fromInput.value = value;
                }

                sliders[sliderId].set([value, null]);
                updateAll(sliders, value, type);
            });
        });
    }
}

$(function () {
    initFilterAgeSliders();

    $('.js-filter-age-type-select').on('change', function () {
        const desiredType = $(this).val();

        $(this).val(desiredType == 'months' ? 'years' : 'months');

        $('.js-filter-age-slider').each(function() {
            const sliderType = $(this).attr('data-type');

            if (sliderType == desiredType) {
                $(this).parents('.js-filter-age-slider-holder').removeClass('is-hidden');
            } else {
                $(this).parents('.js-filter-age-slider-holder').addClass('is-hidden');
            }
        });
    });
});